import React from 'react';
import PropTypes from 'prop-types';
import SelectSearch from 'react-select';
import { removeReactSelectStyles } from './removeReactSelectStyles';

const IgniteDropdownSearch = (props) => {
  const {
    options,
    placeholder,
    value,
    searchValue,
    enableMultipleSelect,
    menuIsOpen,
    onMenuOpenFn,
    onMenuCloseFn,
    onSearchChangeFn,
    noOptionsPlaceholder,
    noOptionsPlaceholderFn,
    onChange = () => {},
    isDisabled = false,
    className = '',
  } = props;

  const flatOptionsList = options
    .map((o) => {
      return o.options ? o.options.flat() : o;
    })
    .flat();

  const onSelectChange = (v) => {
    if (enableMultipleSelect && Array.isArray(v)) {
      onChange(v.map((option) => option.value || option.name));
    } else if (v) {
      onChange(v.value || v.name);
    } else {
      onChange(null);
    }
  };

  const getSelectedValues = () => {
    if (enableMultipleSelect && Array.isArray(value)) {
      return flatOptionsList.filter((o) => value.includes(o.value || o.name));
    } else {
      return flatOptionsList.find((o) => (o.value || o.name) === value);
    }
  };

  const noOptionsFoundFn = (v) => {
    return noOptionsPlaceholderFn && v.inputValue
      ? noOptionsPlaceholderFn(v.inputValue)
      : noOptionsPlaceholder;
  };

  const getControlledProps = () => {
    const ctrlProps = {};
    if (menuIsOpen) ctrlProps.menuIsOpen = menuIsOpen;
    if (searchValue) ctrlProps.inputValue = searchValue;
    if (onMenuOpenFn) ctrlProps.onMenuOpen = onMenuOpenFn;
    if (onMenuCloseFn) ctrlProps.onMenuClose = onMenuCloseFn;
    if (onSearchChangeFn) ctrlProps.onInputChange = onSearchChangeFn;
    return ctrlProps;
  };

  return (
    <>
      <SelectSearch
        isSearchable
        placeholder={placeholder}
        value={value ? getSelectedValues() : null}
        onChange={onSelectChange}
        className={`dropdown-search ${className}`}
        classNamePrefix="dropdown-search"
        options={options}
        isDisabled={isDisabled}
        isMulti={enableMultipleSelect}
        styles={removeReactSelectStyles}
        noOptionsMessage={noOptionsFoundFn}
        {...getControlledProps()}
      />
    </>
  );
};

IgniteDropdownSearch.propTypes = {
  className: PropTypes.string,
  enableMultipleSelect: PropTypes.bool,
  isDisabled: PropTypes.bool,
  menuIsOpen: PropTypes.bool,
  noOptionsPlaceholder: PropTypes.string,
  noOptionsPlaceholderFn: PropTypes.func,
  onChange: PropTypes.func,
  onMenuOpenFn: PropTypes.func,
  onMenuCloseFn: PropTypes.func,
  onSearchChangeFn: PropTypes.func,
  options: PropTypes.array,
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  searchValue: PropTypes.string,
  value: PropTypes.any,
};

export default IgniteDropdownSearch;
